import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { N800 } from '@atlaskit/theme/colors';
import { indentBase } from './styled';
const commonStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  minHeight: 40,
  padding: `${"var(--ds-space-100, 10px)"} ${indentBase} ${"var(--ds-space-100, 10px)"} var(--indent, ${indentBase})`,
  position: 'relative',
  alignItems: 'center',
  color: `var(--ds-text, ${N800})`,
  lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
/**
 * __Common cell__
 */
const CommonCell = ({
  indent,
  width,
  ...props
}) => jsx("div", _extends({
  role: "gridcell"
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props, {
  style: {
    '--indent': indent,
    width
  },
  css: commonStyles
}));
export default CommonCell;